<template>
  <div class="survey-popup d-flex flex-column justify-content-between">
    <div class="top-section">
      <div class="close d-flex justify-content-center align-items-center" @click="cancelSurvey">
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M9.71208 0.287819C9.82924 0.404976 9.82924 0.594926 9.71208 0.712083L0.712083 9.71209C0.594926 9.82924 0.404976 9.82924 0.287819 9.71209C0.170662 9.59493 0.170662 9.40498 0.287819 9.28782L9.28782 0.287819C9.40498 0.170662 9.59493 0.170662 9.71208 0.287819Z" fill="#666666"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M0.287819 0.287819C0.404976 0.170662 0.594926 0.170662 0.712083 0.287819L9.71208 9.28782C9.82924 9.40498 9.82924 9.59493 9.71208 9.71209C9.59493 9.82924 9.40498 9.82924 9.28782 9.71209L0.287819 0.712083C0.170662 0.594926 0.170662 0.404976 0.287819 0.287819Z" fill="#666666"/>
        </svg>
      </div>
      <div class="survey-popup-body">
        <div class="survey-popup-title typo-paragraph16 typo-medium typo-lh20 mb-2 pr-2">{{title}}</div>
        <div class="survey-popup-content">
          <div v-if="isFormPopup">
            <textarea class="text-area mb-2" placeholder="Because..." v-model="message"></textarea>
          </div>
          <div v-else-if="isSubmitted">
            <div class="content typo-paragraph12 typo-regular typo-lh150">Thank you for taking the time to share your experiences with us.</div>
          </div>
          <div v-else>
            <div class="content typo-paragraph12 typo-regular typo-lh150 mb-2 mt-3">We hope that you enjoy building your wonderful pages with GemPages</div>
            <div class="content typo-paragraph12 typo-regular typo-lh150 mb-3">Only {{remainingDays}} day left, do you consider an upgrade to the paid plan?</div>
          </div>
        </div>
      </div>
    </div>
    <div class="survey-popup-action d-flex align-items-center" v-if="!isSubmitted">
      <button class="primary-action btn btn-primary btn-submit" :disabled="!message" v-if="isFormPopup" @click="onSubmit">Submit</button>
      <div v-else class="d-flex align-items-center">
        <button class="primary-action btn btn-primary mr-1" @click="cancelSurvey">Yes, definitely</button>
        <button class="secondary-action btn btn-outline" @click="openSurveyForm">Not sure</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { DASHBOARD_SIDEBAR_EVENT } from "@/config/constants/trackEventIds";

export default {
  name: "SurveyTrial",
  props: {
    remainingDays: Number,
    accountName: String,
    isOpenIntro: Boolean
  },
  data() {
    return {
      isFormPopup: false,
      isLoading: false,
      isSubmitted: false,
      message: null
    };
  },
  computed: {
    title() {
      if (this.isFormPopup) {
        return "Why do you think GemPages is not the best fit for you?";
      } else if (this.isSubmitted) {
        return "Much appreciated!";
      }
      return `Hi ${this.accountName}`
    }
  },
  methods: {
    ...mapActions("common", {
      trackEvent: "trackEvent"
    }),
    ...mapActions("account", {
      closeTrialSurvey: "accountCloseTrialSurvey"
    }),
    openSurveyForm() {
      this.isFormPopup = true;
    },
    cancelSurvey() {
      this.isFormPopup = false;
      this.isSubmitted = false;
      this.closeTrialSurvey({
        data: {trialSurveyClosed: true}
      }) 
      this.$emit("cancelSurvey");
    },
    onSubmit() {
      this.trackEvent({
        event_id: DASHBOARD_SIDEBAR_EVENT.TRIAL_SURVEY_MESSAGE_SUBMITTED,
        properties: {
          user_message: this.message
        }
      });
      this.isSubmitted = true;
      this.isFormPopup = false;
      this.closeTrialSurvey({
        data: {trialSurveyClosed: true}
      }) 
    }
  }
}
</script>

<style lang="scss" scoped>

  .survey-popup {
    width: 280px;
    min-height: 148px;
    border-radius: 3px;
    padding: 22px 16px 24px 16px;
    background-color: map-get($light-grey, "600");
    position: absolute;
    bottom: 90%;
    left: 24px;
    z-index: 99;
    box-shadow: 0px 12px 26px 0px #0000000F;
    &::after {
      content: "";
      position: absolute;
      top: 100%;
      left: 38px;
      margin-left: -5px;
      border-width: 8px;
      border-style: solid;
      border-color: map-get($light-grey, "600") transparent transparent transparent;
    }
  }

  .survey-popup-title {
    color: $mono3;
  }
  
  .secondary-action {
    color: $textLightModeHigh;
    outline-color: $textLightModeHigh;
    line-height: 16px !important;
    width: 110px;
    height: 32px;
  }

  .primary-action {
    color: $light1;
    outline-color: $textLightModeHigh;
    line-height: 16px !important;
    width: 130px;
    height: 32px;
  }

  .content {
    color: $textLightModeLow;
  }

  .text-area {
    height: 90px;
    width: 100%;
    border-radius: 3px;
    border: solid 1px #D6D6D6;
    resize: none;
    padding-left: 8px;
    &:focus {
      border-color: $cPrimary;
    }
  }

  .btn-submit {
    flex-grow: 1;
  }

  .close {
    position: absolute;
    right: 8px;
    top: 21px;
    width: 24px;
    height: 24px;
    border-radius: 3px;
    background: map-get($light-grey, "600");
    color: $textLightModeLow;
    cursor: pointer;
    &:hover {
      background: $light2;
    }
  }
</style>
